import {Component, OnDestroy, OnInit} from '@angular/core';
import {RegistryService} from '../../../../services/registry.service';
import {CartService} from '../../../../services/cart.service';
import {Cart} from '../../../../models/CartModels/cart';
import {CartItem} from '../../../../models/CartModels/cartItem';
import {GoogleAnalyticsService} from "../../../../services/google-analytics.service";

@Component({
    selector: 'app-cart-icon',
    templateUrl: './cart-icon.component.html',
    styleUrls: ['./cart-icon.component.css']
})
export class CartIconComponent implements OnInit,OnDestroy {


    products_count = 0;
    cart: Cart;
    baseImageUrl;
    sum = 0.0;

    currencyChangedEvent;

    current_currency;
    rate;

    constructor(public registry: RegistryService,
                private cartService: CartService,
                private googleService: GoogleAnalyticsService
    ) {

        this.current_currency = registry.current_currency;
        this.currencyChangedEvent = this.registry.CurrencyChangedEvent$.subscribe(currency => {

            this.current_currency = currency;
            this.rate = this.registry.getExchangeRate();
   //         this.recalcPrice();

        });

        this.baseImageUrl = registry.baseImageUrl;

        cartService.CartChangedEvent$.subscribe(cart => {

            this.cart = cart;
            this.products_count = cart?.items?.length;
            this.sum = this.getCartSum(cart?.items);

        });

    }



    getCartSum(items: CartItem[]) {

        let sum = 0;
        for (let i = 0; i < items?.length; i++) {
            sum += (items[i].qty * items[i].price);
        }

        return Math.round((sum + Number.EPSILON) * 100) / 100; // math.round(sum)

    }

    removeSearchBarValue(event) {
        event.preventDefault();
        localStorage.setItem('searchKeyword' , '');
    }

    ngOnInit(): void {

       // this.price = this.item.price * this.registry.getExchangeRate();
        this.rate = this.registry.getExchangeRate();

        if (this.registry.cart != null) {
            this.cart = this.registry.cart;
            this.products_count = this.cart.items.length;
            this.sum = this.getCartSum(this.cart.items);
        }
    }


    loadCart() {

        // this.cartService.loadGuestCartFull(this.cart);

    }

    removeCartItem(item: CartItem) {

        this.cartService.deleteCartItem(this.cart, item.item_id).subscribe(result => {

            const index = this.cart.items.indexOf(item);
            this.cart.items.splice(index, 1);
            this.registry.cart = this.cart;
            this.products_count = this.cart.items.length;
            this.cartService.EmitCartUpdated(this.cart);
            this.cartService.checkCartReady();
            this.googleService.eventEmitter("remove_from_cart",'shop','cart','click',10);

        });
    }

    ngOnDestroy(): void {

        this.currencyChangedEvent.unsubscribe();
    }
}
